import { useTranslation } from 'react-i18next';

import { EmptyScreen } from '@/features/experiments/screens/EmptyScreen';
import { ProfileSettingRoute } from '@/features/profile-setting/navigation/profileSettingRoute';
import { AppSettingScreen } from '@/features/profile-setting/screens/AppSettingScreen';
import { ChatsScreen } from '@/features/profile-setting/screens/ChatsScreen';
import { NotificationSettingScreen } from '@/features/profile-setting/screens/NotificationSettingScreen';
import { OrganizationActivitiesScreen } from '@/features/profile-setting/screens/OrganizationActivitiesScreen';
import { OrganizationAreaScreen } from '@/features/profile-setting/screens/OrganizationAreaScreen';
import { OrganizationDetailScreen } from '@/features/profile-setting/screens/OrganizationDetailScreen';
import { OrganizationEditScreen } from '@/features/profile-setting/screens/OrganizationEditScreen';
import { OrganizationManagementScreen } from '@/features/profile-setting/screens/OrganizationManagementScreen';
import { OrganizationMembersScreen } from '@/features/profile-setting/screens/OrganizationMembersScreen';
import { OrganizationOverviewScreen } from '@/features/profile-setting/screens/OrganizationOverviewScreen';
import { OrganizationPostsScreen } from '@/features/profile-setting/screens/OrganizationPostsScreen';
import { OrganizationPostsWithActivitiesScreen } from '@/features/profile-setting/screens/OrganizationPostsWithActivitiesScreen';
import { OwnPostsScreen } from '@/features/profile-setting/screens/OwnPostsScreen';
import { PostsWithActivityScreen } from '@/features/profile-setting/screens/PostsWithActivityScreen';
import { ProfileEditScreen } from '@/features/profile-setting/screens/ProfileEditScreen';
import { StatisticsEmailScreen } from '@/features/profile-setting/screens/StatisticsEmailScreen';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { NavigationBar } from '@/navigation/components/navbar/NavigationBar';
import { AppStack } from '@/navigation/stacks/appStack';
import { NavBarType } from '@/navigation/types/navbar';

export const useProfileSettingRouting = () => {
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'routes'
  });
  return {
    profileSettingScreens: [
      <AppStack.Screen
        key={ProfileSettingRoute.ProfileEdit}
        name={ProfileSettingRoute.ProfileEdit}
        component={ProfileEditScreen}
        options={() => ({
          title: t(ProfileSettingRoute.ProfileEdit),
          header: () => <NavigationBar type={NavBarType.MODAL_WITH_CLOSE} />,
          presentation: 'containedModal',
          animation: 'fade'
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.Chats}
        name={ProfileSettingRoute.Chats}
        component={ChatsScreen}
        options={() => ({
          title: t(ProfileSettingRoute.Chats),
          header: () => <NavigationBar title={t(ProfileSettingRoute.Chats)} />
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.MyPosts}
        name={ProfileSettingRoute.MyPosts}
        component={OwnPostsScreen}
        options={() => ({
          title: t(ProfileSettingRoute.MyPosts)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.Participated}
        name={ProfileSettingRoute.Participated}
        component={PostsWithActivityScreen}
        options={() => ({
          title: t(ProfileSettingRoute.Participated)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.OrganizationOverview}
        name={ProfileSettingRoute.OrganizationOverview}
        component={OrganizationOverviewScreen}
        options={() => ({
          title: t(ProfileSettingRoute.OrganizationOverview)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.OrganizationDetail}
        name={ProfileSettingRoute.OrganizationDetail}
        component={OrganizationDetailScreen}
        options={() => ({
          title: t(ProfileSettingRoute.OrganizationDetail)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.OrganizationActivities}
        name={ProfileSettingRoute.OrganizationActivities}
        component={OrganizationActivitiesScreen}
        options={() => ({
          title: t(ProfileSettingRoute.OrganizationActivities)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.OrganizationManagement}
        name={ProfileSettingRoute.OrganizationManagement}
        component={OrganizationManagementScreen}
        options={() => ({
          title: t(ProfileSettingRoute.OrganizationManagement)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.OrganizationMembers}
        name={ProfileSettingRoute.OrganizationMembers}
        component={OrganizationMembersScreen}
        options={() => ({
          title: t(ProfileSettingRoute.OrganizationMembers)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.OrganizationPosts}
        name={ProfileSettingRoute.OrganizationPosts}
        component={OrganizationPostsScreen}
        options={() => ({
          title: t(ProfileSettingRoute.OrganizationPosts)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.OrganizationPostsWithActivities}
        name={ProfileSettingRoute.OrganizationPostsWithActivities}
        component={OrganizationPostsWithActivitiesScreen}
        options={() => ({
          title: t(ProfileSettingRoute.OrganizationPostsWithActivities)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.OrganizationEdit}
        name={ProfileSettingRoute.OrganizationEdit}
        component={OrganizationEditScreen}
        options={{
          title: t(ProfileSettingRoute.OrganizationEdit),
          presentation: 'containedModal',
          animation: 'fade'
        }}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.OrganizationsInArea}
        name={ProfileSettingRoute.OrganizationsInArea}
        component={OrganizationAreaScreen}
        options={() => ({
          title: t('organization-area')
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.AppSetting}
        name={ProfileSettingRoute.AppSetting}
        component={AppSettingScreen}
        options={() => ({
          title: t(ProfileSettingRoute.AppSetting)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.Help}
        name={ProfileSettingRoute.Help}
        component={EmptyScreen}
        options={() => ({
          title: t(ProfileSettingRoute.Help)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.NotificationSetting}
        name={ProfileSettingRoute.NotificationSetting}
        component={NotificationSettingScreen}
        options={() => ({
          title: t(ProfileSettingRoute.NotificationSetting)
        })}
      />,
      <AppStack.Screen
        key={ProfileSettingRoute.StatisticsEmail}
        name={ProfileSettingRoute.StatisticsEmail}
        component={StatisticsEmailScreen}
        options={() => ({
          title: t(ProfileSettingRoute.StatisticsEmail)
        })}
      />
    ]
  };
};
